/**
 * 选择知识库文件
 */
import BaseModal from "..";
import KnowledgeChoice from "./comp";

const KnowledgeChoiceModal = {
  self: null,

  show(data = {}) {
    this.self = BaseModal.show({
      ...data,
      borderRadius: 24,
      maskClosable: false,
      content: (
        <KnowledgeChoice {...data} onClose={() => this.hide()} />
      ),
    });
  },
  hide () {
    if (this.self) {
      this.self.destroy();
      this.self = null;
    }
  }
};

export default KnowledgeChoiceModal;